import { ClipPath, Defs, G, Path, Rect, Svg } from 'react-native-svg';
import { TIllustrationProps } from '@/common/components/Illustrations/types';

export const LogoAmericanExpress = ({
  width = 49,
  height = 48,
  className,
}: TIllustrationProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 49 48"
      className={className}
      fill="none"
    >
      <G clipPath="url(#clip0_5758_11198)">
        <Path
          d="M40.1321 11.7792L41.6681 7.6032H48.6953V0H0.695312V48H48.6953V40.416H42.0713L39.6233 37.5552L37.0793 40.416H18.2633V25.1712H12.0521L19.8185 7.6032H27.3737L29.1977 11.5872V7.6032H38.5769L40.1417 11.7792H40.1321ZM34.8329 14.544L34.8137 12.864L35.4569 14.544L38.5769 22.8768H41.6777L44.8169 14.544L45.4217 12.8832V22.8864H48.6857V10.08H43.2617L40.7945 16.5792L40.1417 18.336L39.4697 16.5792L36.9929 10.08H31.5689V22.8768H34.8329V14.544ZM27.8057 22.8768H31.5689L25.9337 10.08H21.5657L15.9017 22.8768H19.6169L20.6057 20.4096H26.8169L27.8057 22.8768ZM23.0729 14.4096L23.7161 12.8064L24.3593 14.4096L25.6841 17.6448H21.7481L23.0729 14.4096ZM20.8841 25.1808V37.9296H31.5689V35.1648H24.1481V32.9376H31.4249V30.1824H24.1481V27.9456H31.5689V25.1808H20.8841ZM43.4633 37.9296H47.7065L41.7257 31.5264L47.7065 25.1712H43.5305L39.6713 29.3184L35.8313 25.1712H31.5785L37.5497 31.5744L31.5785 37.9296H35.7065L39.5945 33.7728L43.4633 37.9296ZM45.0761 31.5168L48.6953 35.1936V27.8784L45.0761 31.5072V31.5168Z"
          fill="#006FCF"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_5758_11198">
          <Rect width="48" height="48" fill="white" x="0.695312" y="0" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
